import React from "react";
import { Link } from "react-router-dom";

/** One row in the NotificationBell dropdown. Renders as Link if `n.link` is set. */
export default function NotificationItem({ n, onSelect }) {
  const inner = (
    <div className={`p-3 border-b border-white/5 hover:bg-white/5 cursor-pointer ${n.read ? "opacity-60" : ""}`}>
      <div className="flex items-start gap-2">
        {!n.read && <span className="mt-1.5 w-2 h-2 rounded-full bg-gold shrink-0" />}
        <div className="flex-1">
          <div className="text-sm font-medium">{n.title}</div>
          {n.body && <div className="text-xs text-white/60 mt-0.5">{n.body}</div>}
          <div className="text-[10px] text-white/40 mt-1">{new Date(n.created_at).toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
  if (n.link) {
    return (
      <Link
        to={n.link}
        onClick={() => onSelect(n.notification_id)}
        data-testid={`notification-item-${n.notification_id}`}
      >{inner}</Link>
    );
  }
  return (
    <div
      onClick={() => onSelect(n.notification_id)}
      data-testid={`notification-item-${n.notification_id}`}
    >{inner}</div>
  );
}
